import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderHomeGallery() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >

                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery/Result2025-26.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_1.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_2.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_3.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_4.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_5.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_6.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_7.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_8.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_9.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="gallery-item">
                        <div className="gallery-img">
                            <img src="assets/school/Gallery_10.webp" alt />
                        </div>
                        <div className="gallery-content">
                            <Link className="popup-img gallery-link" to="/gallery"><i className="fal fa-plus" /></Link>
                        </div>
                    </div>
                </SwiperSlide>



            </Swiper>
        </>
    );
}
